export default __webpack_public_path__ + "static/media/AgentDisclaimer.5407b55a.mp4";